export enum TipoIntegracao {

  CALLBACK_REQUEST = 'CALLBACK_REQUEST',
  ASSINATURA_DIGITAL = 'ASSINATURA_DIGITAL'

}